import { APICallProps } from '@types';
import { isMultiRatePayload, toMultiRateStorePayload } from '@utils/multiRatePricing';

/* Both route on the payload's method alone, not on ugly_freight_types_v2: that flag is read at booking only, where the
   form offers PER_ITEM and sends a CPK load as COST_PER_KG (bookingPricingMethod). After that a multi-rate payload
   comes from a shipment booked multi-rate and follows it onto v2 whoever costs, reorders or stores it. */

/** Sends a multi-rate payload to the given v2 endpoint, without the mark that routed it; else untouched. */
export const useMultiRateRoute = () => (v2Url: string, props?: APICallProps): APICallProps | undefined => {
	if (!props || !isMultiRatePayload(props.payload)) return props;
	const { is_multi_rate: _mark, ...payload } = props.payload;
	return {
		...props, payload, overrideUrl: v2Url
	};
};

/** Sends a multi-rate payload to the v1 store as `is_multi_rate`; else untouched. */
export const useMultiRateStore = () => (props?: APICallProps): APICallProps | undefined => {
	if (!props || !isMultiRatePayload(props.payload)) return props;
	return { ...props, payload: toMultiRateStorePayload(props.payload) };
};
